export default __webpack_public_path__ + "static/media/grey-center.1fa1bd8d.svg";